import React from 'react';
import { withTranslation } from 'react-i18next';
import ShuffleVariantIcon from 'mdi-react/ShuffleVariantIcon';

const MoveToBlogButton = ({t, onClick}) => (
    <span className="button-tag"><button
        className="draft_table-btn"
        title={t('posts.articles.tooltips.move_to_another_blog')}
        type="button"
        onClick={onClick}><ShuffleVariantIcon/></button></span>
)

export default withTranslation('dashboard')(MoveToBlogButton);
